export default __webpack_public_path__ + "static/media/Hadestown_action2-960.44e0618f.jpg";